import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  generateSearchFormItem,
  getGameTreeData,
} from "../../../../../utils/helper";
import { SearchAccordion } from "../../../../common";
import { defaultFilter, ISearchProps } from "./type";

const Search = ({
  filter,
  data,
  setFilter,
  popup,
  gameInfos,
}: ISearchProps) => {
  const { t, i18n } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        enableReinitialize={true}
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "common.time",
                },
                {
                  type: "text",
                  name: "transactionID",
                  label: "ClubElectronicGameRecord.transactionID",
                  disable: Boolean(
                    form.values.fakeID !== "" || form.values.gameIDs?.length
                  ),
                },
                {
                  type: "number",
                  name: "roundID",
                  label: "ClubElectronicGameRecord.roundID",
                  disable: form.values.transactionID === "",
                },
                {
                  type: "multiSelect",
                  name: "gameIDs",
                  label: "ClubElectronicGameRecord.gameID",
                  treeData: getGameTreeData(gameInfos, i18n.language),
                  disable: form.values.transactionID !== "",
                },
                {
                  type: "number",
                  name: "fakeID",
                  label: "ClubElectronicGameRecord.fakeID",
                  disable: form.values.transactionID !== "",
                },
                {
                  type: "number",
                  name: "clubsID",
                  label: "ClubElectronicGameRecord.clubID",
                  disable: form.values.transactionID !== "",
                },
              ].filter((v) => {
                return !popup || v.name !== "playerID";
              }) as any,
              defaultFilter(),
              t,
              data
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
